import { Input,Component, OnInit } from '@angular/core';
import { LanguageService } from '@signature-it/ngx-generic/services';

declare var _: any;

@Component({
    selector: 'overlay-image',
    templateUrl: './overlay-image.component.html',
    styleUrls: ['./overlay-image.component.scss'],
    standalone: false
})

export class OverlayImageComponent implements OnInit{

    @Input() overlayImgUrlList: any;
    @Input() splitChar = "|";
    @Input() overlayClassList: any;

    constructor(protected langSvc: LanguageService){
    }

    ngOnInit() {
        if (typeof this.overlayImgUrlList === 'string' &&  this.overlayImgUrlList!= '') {
            this.overlayImgUrlList = this.overlayImgUrlList.split(this.splitChar);
        }
        if (typeof this.overlayClassList === 'string' && this.overlayClassList != '') {
            this.overlayClassList = this.overlayClassList.split(this.splitChar);
        }
    }

}
